import { Component, ViewEncapsulation, Inject, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EndPointUtils } from '../../utilities/end-points.utils';

@Component({
  templateUrl: './media-modal.component.html',
  styleUrls: ['./media-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MediaModalComponent {
  public mediaInfo;
  public imgPath: any;
  constructor(private endPointUtils: EndPointUtils, private router: Router, @Inject(MAT_DIALOG_DATA) public data) {
    this.imgPath = this.endPointUtils.getCloudinaryImageEP('e_crop/c_pad/content/', 1000, 900, 'g_face', 'c_fill');
    this.mediaInfo = data.mediaInfo;
  }
}
